
import { mapGetters, mapActions } from 'vuex'
import UserDropdown from './UserDropdown.vue'
import { STATUS } from '~/status'

export default {
  name: 'VHeader',
  components: { UserDropdown },
  computed: {
    ...mapGetters({
      isAbgewiesen: 'customer/isAbgewiesen',
      isAuxmoney: 'customer/isAuxmoney',
      isNegativSchufa: 'customer/isNegativSchufa',
      isDuration: 'customer/isDuratio',
      status: 'customer/getStatusId'
    }),
    showTelefon () {
      return this.status && !this.isAbgewiesen && !this.isNegativSchufa && !this.isAuxmoney && !this.isDuration && this.goodStatus
    },
    goodStatus () {
      const good = [
        STATUS.ESSEN_BEARBEITUNG,
        STATUS.ESSEN_GENEHMIGT,
        STATUS.VERTRAGZUMKUNDEN,
        STATUS.SALESFORCE,
        STATUS.MSFFAHRTVERTRAG,
        STATUS.DMS,
        STATUS.VERTRAGSEINGANG,
        STATUS.VERTRAGABGELEHNT,
        STATUS.KREDITWIRDAUSBEZAHLT,

        // neu
        STATUS.IMMO_1POSITIVERSPEEDCHECK,
        STATUS.IMMO_2ERSTGESPRACHKLARUNG,
        STATUS.IMMO_3ANGEBOT4UNTERLAGEN,
        STATUS.IMMO_4UNTERLAGENUNVOLLSTANDIG,
        STATUS.IMMO_5PROFIPRUFUNGVEB,
        STATUS.IMMO_6UNTERLAGENVERVOLLSTANDIGEN,
        STATUS.IMMO_7UNTERLAGENBEREIT,
        STATUS.IMMO_8UMGEWANDELTINECHTFALL,
        STATUS.IMMO_9KREDITGENEHMIGT,
        STATUS.IMMO_10VERTRAGZUMKUNDEN,
        STATUS.EGTKLARUNG,
        STATUS.IMMO_AUSBEZAHLT,
        STATUS.IMMO_VERTRAGZURBANK,
        STATUS.IMMO_EP_PRUFUNG
      ]
      return good.includes(this.status)
    }

  },
  methods: {
    ...mapActions({
      resetCustomer: 'customer/resetState'
    }),
    async logout () {
      this.$logout()
      await this.resetCustomer()

      // redirect to https://www.credimaxx.de/login/ after logout
      window.location.href = 'https://www.credimaxx.de/login/'
    }
  }
}
